function isDev() {
    return !(!process.env.NODE_ENV || process.env.NODE_ENV !== 'development')
}

// by pass some game initialization process
const isQuickStart = isDev() && false

const isPassCode = false;

export {isDev, isQuickStart, isPassCode};